(function () {
  'use strict';
  if (window.__bnplInit) return;
  window.__bnplInit = true;

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getPriceMap(block) {
    try { return JSON.parse(block.getAttribute('data-bnpl-prices') || '{}'); }
    catch (e) { return {}; }
  }

  function updateBlock(block, priceCents) {
    if (!priceCents) return;
    var count = parseInt(block.getAttribute('data-bnpl-count'), 10) || 4;
    var amountEl = block.querySelector('[data-bnpl-amount]');
    if (!amountEl) return;
    amountEl.textContent = formatMoney(Math.floor(priceCents / count));
  }

  function selectTab(modal, provider) {
    var tabs = modal.querySelectorAll('[data-bnpl-tab]');
    var contents = modal.querySelectorAll('[data-bnpl-content]');
    var target = provider;
    if (!modal.querySelector('[data-bnpl-tab="' + provider + '"]')) {
      target = tabs.length ? tabs[0].getAttribute('data-bnpl-tab') : null;
    }
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-bnpl-tab') === target;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    contents.forEach(function (c) {
      var on = c.getAttribute('data-bnpl-content') === target;
      c.classList.toggle('is-active', on);
      c.hidden = !on;
    });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, select, textarea';

  function trapFocus(modal, e) {
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      modal.querySelectorAll(FOCUSABLE),
      function (el) { return el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal(block, provider) {
    var modal = block.querySelector('[data-bnpl-modal]');
    if (!modal) return;
    modal.__bnplReturnFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('bnpl-modal-open');
    selectTab(modal, provider);
    var onKeydown = function (e) {
      if (e.key === 'Escape') { closeModal(modal); return; }
      trapFocus(modal, e);
    };
    modal.__bnplOnKeydown = onKeydown;
    document.addEventListener('keydown', onKeydown);
    var focusable = modal.querySelector('.bnpl-modal__gotit, [data-bnpl-close]');
    if (focusable) focusable.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.classList.remove('bnpl-modal-open');
    if (modal.__bnplOnKeydown) {
      document.removeEventListener('keydown', modal.__bnplOnKeydown);
      modal.__bnplOnKeydown = null;
    }
    if (modal.__bnplReturnFocus && typeof modal.__bnplReturnFocus.focus === 'function') {
      modal.__bnplReturnFocus.focus();
    }
    modal.__bnplReturnFocus = null;
  }

  function bindBlock(block) {
    if (block.__bnplBound) return;
    block.__bnplBound = true;

    block.querySelectorAll('[data-bnpl-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(block, btn.getAttribute('data-bnpl-open')); });
    });

    var modal = block.querySelector('[data-bnpl-modal]');
    if (modal) {
      modal.querySelectorAll('[data-bnpl-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeModal(modal); });
      });
      modal.querySelectorAll('[data-bnpl-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () { selectTab(modal, tab.getAttribute('data-bnpl-tab')); });
      });
    }

    var idInput = document.querySelector('product-info input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', function () {
        var price = getPriceMap(block)[idInput.value];
        if (price) updateBlock(block, price);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-bnpl]').forEach(bindBlock);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        document.querySelectorAll('[data-bnpl]').forEach(function (block) { updateBlock(block, variant.price); });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
